import { customEvents, getWebPUrlWithWidth, mergePersistentParams, sendCustomEvent } from '@cx-modules/utils';

import { type ArticleItem } from '../../types/article.types';
import { formatFullTimeDateInTimeZone } from '../../utils';
import { buildArticleUrl } from '../../utils/build-article-url';
import { ImageWrapper } from '../image-wrapper';
import { LockBanner } from '../lock-banner';

import {
  Author,
  Description,
  FlexWrapper,
  imageContainer,
  Item,
  PublishedDate,
  ReadTime,
  Title,
  TitleContainer,
} from './style';

export const ArticleLink = ({
  aiGeneratedId,
  authors = [],
  baseUrl,
  componentTags = [],
  description,
  image,
  isLoggedIn,
  publishedTime,
  readTime,
  repub,
  requestUrl,
  title,
  url,
}: ArticleItem & { baseUrl?: string; isLoggedIn?: boolean; requestUrl?: string }) => {
  const clickHandler = () => {
    sendCustomEvent({
      aiArticle: aiGeneratedId ? 'yes' : 'no',
      articleName: title,
      event: customEvents.ARTICLE_CLICK,
      tipsterName: authors[0].fullName,
    });
  };

  const formattedPublishedTime = formatFullTimeDateInTimeZone(publishedTime, repub);

  const renderWallBanner = componentTags.includes('TIPS_PREMIUM');

  const fullUrl = buildArticleUrl(url, repub, baseUrl);

  return (
    <div>
      {renderWallBanner && <LockBanner isLoggedIn={isLoggedIn} />}
      <Item data-testid="article-item" href={mergePersistentParams(fullUrl, requestUrl)} onClick={clickHandler}>
        {image && (
          <ImageWrapper
            alt={image.alt}
            focusArea={image.focusArea}
            imageContainerClass={imageContainer}
            url={getWebPUrlWithWidth(image.url, 350)}
          />
        )}
        <TitleContainer>
          <Title data-testid="article-title">{title}</Title>
          {description && <Description data-testid="article-description">{description}</Description>}
          <FlexWrapper>
            <div>
              {authors.length && <Author data-testid="article-author">{authors[0].fullName}</Author>}
              {publishedTime && (
                <PublishedDate data-testid="article-published-time">{formattedPublishedTime}</PublishedDate>
              )}
            </div>
            <div>{readTime && <ReadTime data-testid="article-read-time">{readTime}</ReadTime>}</div>
          </FlexWrapper>
        </TitleContainer>
      </Item>
    </div>
  );
};
